module.exports = __webpack_public_path__ + "img/13.d7942f24.png";